import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VendorComponent } from './vendor/vendor.component';
import { LoginComponent } from './login/login.component';
import { BaseAppRouteGuardService } from '../core/services/base-app-route-guard.service';
import { SignUpComponent } from './sign-up/sign-up.component';
import { SetPasswordPage } from './set-password/set-password.page';
import { DashboardPage } from './dashboard/dashboard.page';
import { ProfilePage } from './profile/profile.page';
import { VendorAuthGuardService } from '../core/services/vendor-services/vendor-auth-guard.service';
import { ForgotPasswordPage } from './forgot-password/forgot-password.page';
import { ResetPasswordPage } from './reset-password/reset-password.page';
import { VendorUpdateComponent } from '../vendor-list/vendor-update/vendor-update.component';
import { VendorDetailsComponent } from '../vendor-list/vendor-details/vendor-details.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login'
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'sign-up',
    component: SignUpComponent
  },
  {
    path: 'set-password',
    component: SetPasswordPage
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordPage
  },
  {
    path: 'reset-password',
    component: ResetPasswordPage
  },

  {
    path: 'baseapp',
    component: VendorComponent,
    canActivate: [VendorAuthGuardService],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard'
      },
      {
        path: 'dashboard',
        component: DashboardPage
      },
      {
        path: 'profile',
        component: ProfilePage
      },
      { 
        path: 'update/:id',
        component: VendorUpdateComponent
      },
      {
        path: 'details/:id',
        component:  VendorDetailsComponent
      }  
    ]
  },
  {
    path: '**', redirectTo: 'login'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class VendorRoutingModule { }
